import React from 'react';
import HybridLinkGroup from '../HybridLinkGroup';
import HybridLinkWidget from '../HybridLinkWidget';
import './scss/LayoutOne.scss';

const LayoutOne = (props = {}) => {
	const data = props.data || {};

	return (
		<div className="container-fluid footer-layout-one">
			<div className="container" >
				<div className="flex-widget">
					{
						data.map((widget, index) => {
							const widgetData = widget || {},
								type = widgetData.type || "HybridLinkWidget",
								key = `hlw-${index}`;

							return (
								(type === "HybridLinkGroup") ? <HybridLinkGroup data={widget} key={key}/> : <HybridLinkWidget data={widget} key={key}/>
							);
						})
					}
				</div>
			</div>
		</div>
	);
};

export default LayoutOne;